import React, { useCallback } from 'react';
import useToggle from 'react-use/lib/useToggle';
import styled from 'styled-components';
import { Typography, TypographyProps } from './Typography';

interface TypographyExpanderProps extends Omit<TypographyProps, 'lines' | 'backgroundColor'> {
    lines: number;
    expanded?: boolean;
    backgroundColor: string;
    onExpand?: VoidFunction;
}

const TypographyExpanderRoot = styled(Typography)
    .attrs<TypographyExpanderProps, TypographyExpanderProps>(
        ({ lines, backgroundColor, ...other }) => other,
    )
    .withConfig({
        displayName: 'TypographyExpanderRoot',
        shouldForwardProp: (prop) => !['lines', 'backgroundColor'].includes(prop),
    })`
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    max-height: ${(props) => `calc(${props.lines} * var(--line-height))`};

    &::after {
        content: 'Узнать больше…';
        position: absolute;
        color: var(--color-secondary);
        top: ${(props) => `calc(var(--line-height) * ${props.lines - 1})`};
        width: 100%;
        background: ${(props) => props.backgroundColor};
        left: 0;
        cursor: pointer;
    }

`;

export function TypographyExpander(props: TypographyExpanderProps) {
    const { children, expanded, lines, onExpand, ...other } = props;
    const [isTruncated, toggleIsTruncated] = useToggle(!expanded);
    const handleClick = useCallback(() => {
        toggleIsTruncated(false);

        if (!expanded) {
            onExpand?.();
        }
    }, [expanded, toggleIsTruncated, onExpand]);

    return (
        <TypographyExpanderRoot {...other} lines={isTruncated ? lines : 999} onClick={handleClick}>
            {children}
        </TypographyExpanderRoot>
    );
}
